/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

interface Props {
  className: any;
}

export const LifeBuoy02 = ({ className }: Props): JSX.Element => {
  return (
    <svg
      className={`${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_175_4988)">
        <path
          d="M7.05367 7.05369L4.1074 4.10742M4.1074 15.8925L7.05369 12.9462M12.9462 12.9462L15.8925 15.8925M15.8925 4.10738L12.9462 7.05367M18.3333 9.99996C18.3333 14.6023 14.6023 18.3333 9.99996 18.3333C5.39759 18.3333 1.66663 14.6023 1.66663 9.99996C1.66663 5.39759 5.39759 1.66663 9.99996 1.66663C14.6023 1.66663 18.3333 5.39759 18.3333 9.99996ZM14.1666 9.99996C14.1666 12.3011 12.3011 14.1666 9.99996 14.1666C7.69877 14.1666 5.83329 12.3011 5.83329 9.99996C5.83329 7.69877 7.69877 5.83329 9.99996 5.83329C12.3011 5.83329 14.1666 7.69877 14.1666 9.99996Z"
          stroke="url(#paint0_linear_175_4988)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M7.05367 7.05369L4.1074 4.10742M4.1074 15.8925L7.05369 12.9462M12.9462 12.9462L15.8925 15.8925M15.8925 4.10738L12.9462 7.05367M18.3333 9.99996C18.3333 14.6023 14.6023 18.3333 9.99996 18.3333C5.39759 18.3333 1.66663 14.6023 1.66663 9.99996C1.66663 5.39759 5.39759 1.66663 9.99996 1.66663C14.6023 1.66663 18.3333 5.39759 18.3333 9.99996ZM14.1666 9.99996C14.1666 12.3011 12.3011 14.1666 9.99996 14.1666C7.69877 14.1666 5.83329 12.3011 5.83329 9.99996C5.83329 7.69877 7.69877 5.83329 9.99996 5.83329C12.3011 5.83329 14.1666 7.69877 14.1666 9.99996Z"
          stroke="url(#paint1_linear_175_4988)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeOpacity="0.16"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_175_4988"
          x1="-5.94642"
          x2="10.2401"
          y1="10.2401"
          y2="26.4265"
        >
          <stop stopColor="#7549F4" />
          <stop offset="1" stopColor="#FCA6E9" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint1_linear_175_4988"
          x1="9.99996"
          x2="9.99996"
          y1="1.66663"
          y2="18.3333"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_175_4988">
          <rect fill="white" height="20" width="20" />
        </clipPath>
      </defs>
    </svg>
  );
};
